module.exports = __webpack_public_path__ + "static/media/sliderImage3.9a815e07.png";